import { defineStore } from 'pinia'
import iconModeAgent from '@/assets/icon/ic-mode-agent.png'
import iconModeAgentSelected from '@/assets/icon/ic-mode-agent-2.png'
import iconModeImage from '@/assets/icon/ic-image-black.png'
import iconModeImageSelected from '@/assets/icon/ic-image-blue.png'
import iconModeText from '@/assets/icon/ic-mode-text.png'
import iconModeTextSelected from '@/assets/icon/ic-mode-text-2.png'
import iconRatio_1_1 from '@/assets/icon/ic-ratio-1-1.png'
import iconRatio_2_3 from '@/assets/icon/ic-ratio-2-3.png'
import iconRatio_3_2 from '@/assets/icon/ic-ratio-3-2.png'
import iconRatio_3_4 from '@/assets/icon/ic-ratio-3-4.png'
import iconRatio_4_3 from '@/assets/icon/ic-ratio-4-3.png'
import iconRatio_9_16 from '@/assets/icon/ic-ratio-9-16.png'
import iconRatio_16_9 from '@/assets/icon/ic-ratio-16-9.png'

export const useConstantStore = defineStore('constant', {
  state: () => ({
    TaskTypeList: [
      {
        label: 'Auto Design',
        value: 'auto_image_create',
        icon: iconModeAgent,
        iconSelected: iconModeAgentSelected,
      },
      {
        label: 'By Reference',
        value: 'reference_image_create',
        icon: iconModeImage,
        iconSelected: iconModeImageSelected,
      },
      {
        label: 'Chat Create',
        value: 'message_image_create',
        icon: iconModeText,
        iconSelected: iconModeTextSelected,
      },
    ],
    GenerateModeMap: {
      auto_image_create: {
        title: 'Target of Creation',
        list: [
          {
            label: 'Create Mockup',
            value: 'normal',
          },
          {
            label: 'Replace Background',
            value: 'change_background',
          },
        ],
      },
      reference_image_create: {
        title: 'Purpose of Reference',
        list: [
          {
            label: 'Match Scene',
            value: 'normal',
          },
          {
            label: 'Apply Background',
            value: 'change_background',
          },
          {
            label: 'Swap Objects',
            value: 'partial_replacement',
          },
        ],
      },
    },
    GenerateNumberList: [
      {
        label: '1',
        value: 1,
      },
      {
        label: '2',
        value: 2,
      },
      {
        label: '3',
        value: 3,
      },
      {
        label: '4',
        value: 4,
      },
    ],
    GenerateRatioList: [
      {
        label: '2:3',
        value: '2:3',
        icon: iconRatio_2_3,
      },
      {
        label: '3:2',
        value: '3:2',
        icon: iconRatio_3_2,
      },
      {
        label: '3:4',
        value: '3:4',
        icon: iconRatio_3_4,
      },
      {
        label: '4:3',
        value: '4:3',
        icon: iconRatio_4_3,
      },
      {
        label: '9:16',
        value: '9:16',
        icon: iconRatio_9_16,
      },
      {
        label: '16:9',
        value: '16:9',
        icon: iconRatio_16_9,
      },
      {
        label: '1:1',
        value: '1:1',
        icon: iconRatio_1_1,
      },
    ],
  }),
  getters: {},
  actions: {},
})
